import type { FC } from "react";
import { twMerge } from "tailwind-merge";

interface VerticalDividerProps {
  className?: string;
}

export const VerticalDivider: FC<VerticalDividerProps> = ({ className }) => {
  return <div className={twMerge("border-r border-blue-tint-93", className)} />;
};
